module.exports = __webpack_public_path__ + "static/media/icon-play.f54f90e5.svg";